import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useDiscoverShelves() {
  return useQuery({
    queryKey: ['books', 'discover-shelves'],
    queryFn: () => libraryApi.getDiscoverShelves(),
    staleTime: 10 * 60 * 1000,
  });
}
